var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.value)?_c('em',{staticClass:"text-info"},[_vm._v("\n        None\n    ")]):_c('BadgeTotal',{attrs:{"value":_vm.value,"color":_vm.color}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }